import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

import type { CreateEditService } from "./service"

export type CreateServiceRequest = CreateEditService

export const createService = async (
  params: CreateServiceRequest
) => {
  await api.post("/beepaidgo/services/", { body: params })

  queryClient.invalidateQueries([SERVICES_QUERY_KEY])
}
